<script lang="ts" setup>

  // Idioma
  const { locale, setLocaleCookie } = useI18n()
  const switchLocalePath = useSwitchLocalePath()
  useHead({ // añadir idioma al documento
    htmlAttrs: { lang: locale.value.substring(0, 2) },
  })

  const selectedIdioma = ref(locale.value)
  setLocaleCookie(locale.value)
  watch(selectedIdioma, (value) => { // reload en cambio de idioma
    reloadNuxtApp({
      path: switchLocalePath(value)
    })
  },{ immediate: false })

  // Menu
  const open = ref(false)

  // Color header
  const isScrolledHeader = ref(false) // detectar el scroll para cambiar color texto header
  onMounted(() => {
    const checkScrollHeader = () => {
      const height = window.innerHeight - 80 - 16 // innerHeight - 80 del hero y 16px del Header
      isScrolledHeader.value = window.scrollY > height
    }
    window.addEventListener('scroll', checkScrollHeader)
  })

  // Home Store
  const { isHome } = useIsHome()

  // Header links
  const carouselContainer = ref(null)
  const links = ref([
    { name: 'Vuelos', src: '/img/icons/icons-header/vuelos-select.svg', to: 'https://mundojoven.com/vuelos' },
    { name: 'Seguros', src: '/img/icons/icons-header/seguros-select.svg', to: 'https://www.mundojoven.com/seguros' },
    { name: 'Tours', src: '/img/icons/icons-header/tours-select.svg', to: 'https://www.mundojoven.com/tours' },
    { name: 'Vuelo + Hotel', src: '/img/icons/icons-header/vueloshotel-select.svg', to: 'https://www.mundojoven.com/paquetes' },
    { name: 'Hoteles', src: '/img/icons/icons-header/hotel-select.svg', to: 'https://www.mundojoven.com/hoteles' },
    { name: 'Hoteles por horas', src: '/img/icons/icons-header/byhours.svg', to: 'https://byhours.mundojoven.com/es', active: true },
    { name: 'Playas', src: '/img/icons/icons-header/playas-select.svg', to: 'https://www.mundojoven.com/playas-nacionales' },
    { name: 'Travelers', src: '/img/icons/icons-header/travelers-select.svg', to: 'https://www.mundojoven.com/travelers' },
    { name: 'Actividades', src: '/img/icons/icons-header/actividades.svg', to: 'https://www.mundojoven.com/actividades' },
    { name: 'Renta autos', src: '/img/icons/icons-header/renta-select.svg', to: 'https://autos.mundojoven.com/' },
    { name: 'Cruceros', src: '/img/icons/icons-header/cruceros.svg', to: 'https://mundojoven.com/cruceros' },
    { name: 'Parques', src: '/img/icons/icons-header/disney.png', to: 'https://paqnacionales.mundojoven.com/experiencias/disney' },
    { name: 'ISIC Tarjeta Estudiante', src: '/img/icons/icons-header/isic-select.svg', to: 'https://www.isic.org.mx/' },
    { name: 'Ofertas irresistibles', src: '/img/icons/icons-header/ofertas-select.svg', to: 'https://www.mundojoven.com/ofertas-irresistibles' },
    { name: 'Estudios en el extranjero', src: '/img/icons/icons-header/estudios-select.svg', to: 'https://www.mundojoven.com/estudios-en-el-extranjero' },
    { name: 'Grupos', src: '/img/icons/icons-header/peoples-two.png', to: 'https://mundojovengrupos.com/' }
  ])

  onMounted(() => { // scroll al elemento activo del header
    const activeItem = document.querySelector('.activeLink')
    activeItem?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    })
  })

  // Contact links
  const contactLinks = ref([
    { src: '/img/icons/icons-header/whatsapp-icon.png', text: '', link: 'https://api.whatsapp.com/send?phone=5215587351623' },
    { src: '/img/icons/icons-header/phone-call.svg', text: '(55) 54 82 82 82', link: 'tel:(55)54828282' },
    { src: '/img/icons/icons-header/blog.svg', text: 'Nuestro blog', link: 'https://viajerosinspirandoviajeros.com/' },
    { src: '/img/icons/icons-header/shop.svg', text: 'Sucursales Mundo Joven', link: 'https://mundojoven.com/sucursales' }
  ])

  // Modal links
  const modalLinks = ref([
    { label: 'Sucursales', to: 'https://mundojoven.com/sucursales', src: '/img/icons/icons-header/shop.svg' },
    { label: 'Blog', to: 'https://viajerosinspirandoviajeros.com/', src: '/img/icons/icons-header/blog.svg' },
    { label: 'Quienes somos', to: 'https://mundojoven.com/quienes-somos', src: '/img/icons/icons-header/passport.svg' },
    { label: 'Viajes en grupos', to: 'https://mundojovengrupos.com/', src: '/img/icons/icons-header/peoples-two.png' },
    { label: 'Franquicias', to: 'https://franquicias.mundojoven.com/', src: '/img/icons/icons-header/franquicias.svg' },
    { label: '(55) 54 82 82 82', to: 'tel:(55) 54 82 82 82', src: '/img/icons/icons-header/phone-call.svg' },
    { label: 'Escribenos por whatsapp', to: 'https://api.whatsapp.com/send?phone=5215587351623', src: '/img/icons/icons-header/whatsapp-icon.png' },
  ])

  // Redes
  const socialLinks = ref([
    { label: 'Instagram', src: '/img/icons/icons-header/instagram.svg', to: 'https://www.instagram.com/MundoJoven/' },
    { label: 'TikTok', src: '/img/icons/icons-header/tiktok.svg', to: 'https://www.tiktok.com/@mundojovenoficial' },
    { label: 'Facebook', src: '/img/icons/icons-header/facebook.svg', to: 'https://es-la.facebook.com/mundojoven' },
    { label: 'Youtube', src: '/img/icons/icons-header/youtube.svg', to: 'https://www.youtube.com/mundojoven' },
    { label: 'X', src: '/img/icons/icons-header/big-x.svg', to: 'https://x.com/mundo_joven' },
  ])

</script>

<template>
  <header class="h-full top-0 left-0 right-0 w-full z-50 backdrop-blur-lg sticky transition bg-white/80">
    <div class="px-4 py-2 md:py-0 md:mb-2 mx-auto flex justify-between items-center h-full" :class="`${ isHome ? 'max-w-screen-xl' : 'max-w-screen-2xl'}`">
      <div class="flex flex-col gap-4 w-full">
        <div class="flex items-center gap-2 justify-between w-full">

          <!-- Menu -->
          <div class="md:hidden">
            <USlideover v-model:open="open" side="top">
              <UButton
                aria-label="Desplegar menú"
                icon="i-heroicons-bars-3-16-solid"
                color="neutral"
                variant="link"
              />

              <template #header>
                <div class="w-full flex items-center justify-between">
                  <div class="px-4">
                    <NuxtLink aria-label="Home" :to="`/${locale}`">
                      <NuxtImg preload alt="Logo" src="/img/logo.png" sizes="200px xl:250px" :class="['transition']" />
                    </NuxtLink>
                  </div>

                  <UButton aria-label="Cerrar" icon="i-heroicons-x-mark-20-solid" color="neutral" variant="link" @click="open = false" />
                </div>
              </template>

              <template #body>
                
                <!-- Items menu -->
                <div v-for="item in modalLinks" :key="item.label">
                  <UButton
                    size="lg"
                    color="neutral"
                    variant="link"
                    :aria-label="item.label"
                    :label="item.label"
                    :to="item.to"
                    target="_blank"
                    class="w-full mb-2 font-semibold"
                    @click="open = false"
                  >
                    <template #leading>
                      <NuxtImg :src="item.src" width="23" class="min-w-5" />
                    </template>
                  </UButton>
                </div>

                <!-- Redes -->
                <div class="flex justify-between px-6 py-1">
                  <UButton
                    v-for="item in socialLinks" :key="item.src"
                    :aria-label="item.label"
                    size="md"
                    color="neutral"
                    variant="link"
                    :to="item.to"
                    target="_blank"
                  >
                  <template #leading>
                    <NuxtImg :src="item.src" width="20" class="min-w-5" />
                  </template>
                  </UButton>
                </div>

              </template>
            </USlideover>
          </div>
          
          <!-- Logo -->
          <div :class="['min-w-16', {'hidden md:block': !isHome}]">
            <NuxtLink aria-label="Home" :to="`/${locale}`" @click.stop.prevent="open = false" >
              <NuxtImg preload alt="Logo" src="/img/logo.png" sizes="200px xl:250px" :class="['transition']" />
            </NuxtLink>
          </div>

          <!-- Inputs -->
          <div :class="['xl:flex']" v-if="!isHome">
            <SearchInput />
          </div>

          <div class="flex items-center">

            <!-- Contacto -->
            <div :class="`${!isHome ? 'hidden' : 'flex'} md:bg-neutral-100 first:rounded-bl-lg last:rounded-br-lg md:flex h-full font-bold text-sm`">
              <NuxtLink 
                :to="item.link"
                target="_blank" 
                v-for="(item, index) in contactLinks"
                :key="item.text"
                class="flex py-2 md:py-5 items-center hover:bg-neutral-50 md:first:rounded-bl-lg md:last:rounded-br-lg gap-2"
                :class="{
                  'order-last md:order-none px-2 md:pl-6 md:pr-0': index === 0, 
                  'px-2 md:pr-6 md:pl-2': index === 1,
                  'hidden md:flex px-6': index === 2,
                  'order-first md:order-none px-2 md:px-6': index === 3, 
                }"
              >
                <div class="flex gap-3 aspect-square">
                  <NuxtImg 
                    preload 
                    :src="item.src" 
                    sizes="20px md:25px" 
                    class="min-w-5" 
                  />
                </div>
                <span class="hidden xl:block">{{ item.text }}</span>
              </NuxtLink>
            </div>

          </div>

        </div>

        <!-- Menu -->
        <!-- <div ref="carouselContainer">
          <UCarousel
            ref="carousel"
            v-slot="{ item }"
            :items="links"
            :ui="{
              item: 'basis-1/12 ps-0',
              prev: 'sm:start-8',
              next: 'sm:end-8',
              container: 'ms-0'
            }"
            :prev-button="{
              color: 'gray',
              class: 'hidden'
            }"
            :next-button="{
              color: 'gray',
              class: '-end-4 flex md:hidden'
            }"
          >
            <NuxtLink :to="item?.to ?? ''" :target="item?.active ? '_self' : '_blank'" class="flex flex-col items-center" :class="{ 'border-b-2 border-mundojoven-700 activeLink' : item?.active }">
              <div class="aspect-square"><NuxtImg :src="item?.src" class="w-6 min-h-6" /></div>
              <span>{{ item?.name }}</span>
            </NuxtLink>
          </UCarousel>
        </div> -->

      </div>
    </div>
  </header>
</template>

<style scoped>
  a:hover {
    text-decoration: underline;
  }
</style>